import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import * as classNames from 'classnames';

interface IDelayedSpinnerOwnProps {
  containerClassName?: string;
  progressClassName?: string;
  delay?: number;
  backdrop?: boolean;
}

export const DelayedSpinner = ({ containerClassName, progressClassName, backdrop, delay = 750 }: IDelayedSpinnerOwnProps) => {
  const [showSpinner, setShowSpinner] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setShowSpinner(true), delay);

    return () => clearTimeout(timer);
  }, []);

  const spinner = (
    <div className={classNames('recreogo-delayedSpinner__progress-container', containerClassName)}>
      <CircularProgress color="primary" className={classNames('recreogo-delayedSpinner-calendar__progress', progressClassName)} />
    </div>
  );

  if (backdrop) {
    return (
      <Backdrop className="recreogo-delayedSpinner__backdrop" open>
        {showSpinner && spinner}
      </Backdrop>
    );
  }

  return showSpinner && spinner;
};

export default DelayedSpinner;
